export default "__VITE_ASSET__DXInjGhS__"